import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { ResponsesBalanceResponse } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { dataContent } from '../../../../../../constants';
import { DetailsStatementsItem } from '../DetailsStatementsItem';
import { TableHead } from '../TableHead';

interface DetailsStatementsTableProps {
  data: ResponsesBalanceResponse[];
}

export const DetailsStatementsTable: React.FC<DetailsStatementsTableProps> = ({ data }) => {
  const viewportType = useBreakpointValue({ base: 'tablet', lg: 'desktop' });
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { tableHead, widthCols } = dataContent.pensionDetailsStatements;
  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.dark">
        Extrato detalhada
      </Text>
      <Box>
        {!isMobile && (
          <TableHead viewportType={viewportType} tableHead={tableHead} widthCols={widthCols} />
        )}
        <FlatList
          data={data}
          showsVerticalScrollIndicator={false}
          keyExtractor={(item, index) => `${item.balanceDate}-${index}`}
          renderItem={({ item, index }) => (
            <DetailsStatementsItem item={item} isLastItem={index === data.length - 1} />
          )}
        />
      </Box>
    </VStack>
  );
};
